export default __webpack_public_path__ + "static/media/lp-sec02_txt.062718e4.png";